<template>
  <div class="prescription">
    <div class="bg_fff pt10 pb10 pl15 pr15">
      <el-row>
        <el-button type="primary" plain @click="addTab(1)"
          >添加西成药方</el-button
        >
        <el-button type="primary" plain @click="addTab(3)"
          >添加草药方</el-button
        >
        <el-button type="primary" v-if="!reSub" @click="submitPrescription"
          >保存处方</el-button
        >
        <el-button type="primary" style="float: right" @click="shareClick"
          >共享处方查阅</el-button
        >
        <el-button
          type="primary"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="reSubPrescription(patientInfo.id)"
          v-if="reSub"
          >重新保存处方</el-button
        >
      </el-row>
    </div>
    <div class="mt10 flex jcb">
      <div :class="display ? 'width100 bg_fff' : 'width70 bg_fff'">
        <el-tabs
          v-model="activeTab"
          type="card"
          closable
          @tab-remove="removeTab"
          @tab-click="tabChange"
        >
          <el-tab-pane
            v-for="(item, index) in tabsList"
            :key="item.name"
            :z-index="index"
            :label="item.title"
            :name="item.name"
          >
            <div
              class="pb10 flex column relative"
              v-if="
                item.orderType == 'WESTERN_RECIPE' ||
                item.orderType == 'PRESCRIPT_RECIPE'
              "
            >
              <!-- :style="{ height: clientHeight - 150 + 'px' }" -->

              <div class="flex jce pr10 color_main">西成药方</div>
              <p class="fs20 bold flex jcc">{{ hosName }}</p>
              <p class="fs16 mt10 flex jcc">处方笺</p>
              <span class="sign signC" v-if="subStatus">已提交</span>
              <span class="sign" v-else>未提交</span>
              <div class="pat-info flex column">
                <div class="flex pl30 mt30">
                  <span class="info-label">姓名：</span
                  ><span class="info-item">{{ patientInfo.compatName }}</span>
                  <span class="info-label">性别：</span
                  ><span class="info-item">{{
                    patientInfo.compatGender | sexFilter(1)
                  }}</span>
                  <span class="info-label">年龄：</span
                  ><span class="info-item">{{ patientInfo.compatAge }}</span>
                  <span class="info-label">科别：</span
                  ><span class="info-item">{{ patientInfo.deptName }}</span>
                  <span class="info-label">过敏史：</span>
                  <el-autocomplete
                    style="width: 300px"
                    size="mini"
                    v-model="tabsList[idx].allergyHistoryValue"
                    :fetch-suggestions="allergy"
                    @select="
                      (selectItem) => {
                        allergyHandleSelect(selectItem);
                      }
                    "
                    @keydown.native="deleteAllergyHistory"
                  ></el-autocomplete>
                </div>
                <div class="flex pl30 mt15">
                  <span class="info-label">电话：</span
                  ><span class="info-item">{{ patientInfo.compatMobile }}</span>
                  <span class="info-label">开方日期：</span
                  ><span class="info-item">{{ tDate }}</span>
                  <span class="info-label">住址：</span
                  ><span class="info-item width20 ellipsis">{{
                    patientInfo.areaName
                  }}</span>
                </div>
                <div class="flex pl30 mt15">
                  <span class="info-label">诊断：</span>
                  <el-autocomplete
                    style="width: 100%"
                    size="mini"
                    v-model="tabsList[idx].diagnosisValue"
                    :fetch-suggestions="fetchDiagnosis"
                    @select="
                      (item) => {
                        selectDiagnose(item);
                      }
                    "
                    @keydown.native="deleteDiagnosis"
                  ></el-autocomplete>
                </div>
              </div>
              <div class="medicine-table">
                <el-table
                  :data="tabsList[idx].drugList"
                  border
                  style="width: 100%"
                >
                  <el-table-column type="index" width="20"></el-table-column>
                  <el-table-column prop="name" label="药品名称" width="140">
                    <template slot-scope="scope">
                      <el-autocomplete
                        style="width: 300px"
                        size="mini"
                        v-model="scope.row.name"
                        :fetch-suggestions="fetchMedicine"
                        @select="
                          (selectItem) => {
                            handleSelect(selectItem, scope.$index);
                          }
                        "
                      ></el-autocomplete>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="specification"
                    label="规格"
                  ></el-table-column>
                  <el-table-column prop="unit" label="单位"></el-table-column>
                  <!-- <el-table-column
                    prop="inventory"
                    label="库存"
                  ></el-table-column> -->
                  
                  <el-table-column prop="price" label="单价">
                    <template> </template>
                  </el-table-column>
                  <el-table-column prop="dose" label="每次剂量" width="80">
                    <template slot-scope="scope">
                      <el-input
                        size="mini"
                        v-model="scope.row.dose"
                        @input="getDays(scope.$index, scope.row)"
                      ></el-input>
                      <!-- <el-select v-model="scope.row.dosage" size="mini">
                    <el-option
                      v-for="item in singleDoseList"
                      :key="item.id"
                      :label="item.dicName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select> -->
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="doseUnit"
                    label="剂量单位"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    prop="drugAdmission"
                    label="用法"
                    width="100"
                  >
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.admissionId" size="mini">
                        <el-option
                          v-for="item in drugAdmissionList"
                          :key="item.id"
                          :label="item.dicName"
                          :value="item.dicCode"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="frequencyCode"
                    label="使用频次"
                    width="140"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.dicCode"
                        size="mini"
                        @change="getDays(scope.$index, scope.row)"
                      >
                        <el-option
                          v-for="item in drugFrequencyList"
                          :key="item.id"
                          :label="item.dicName"
                          :value="item.dicCode"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="date" label="数量">
                    <template slot-scope="scope">
                      <el-input
                        size="mini"
                        v-model="scope.row.amount"
                        @input="getDays(scope.$index, scope.row)"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="date" label="天数">
                    <template slot-scope="scope">
                      <el-input
                        size="mini"
                        v-model="scope.row.useDays"
                        :disabled="true"
                      ></el-input>
                    </template>
                  </el-table-column>

                  
                  <!-- <el-table-column
                    prop="originPlace"
                    label="药品产地"
                  ></el-table-column> -->
                  <el-table-column prop="date" label="操作">
                    <template slot-scope="scope">
                      <span
                        class="color_red fs18 pointer"
                        v-if="
                          scope.$index > 0 || tabsList[idx].drugList.length > 1
                        "
                        @click="medicineDelete(scope.$index, scope.row)"
                        >x</span
                      >
                      <span
                        class="color_main fs18 pointer ml10"
                        v-if="scope.$index == tabsList[idx].drugList.length - 1"
                        @click="medicineAdd(scope.$index, scope.row)"
                        >+</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div
              class="pb10 flex column relative"
              :style="{ height: clientHeight - 150 + 'px' }"
              v-else-if="item.orderType == 'CHINESE_RECIPE'"
            >
              <div class="flex jce pr10 color_main">草药方</div>
              <p class="fs20 bold flex jcc">{{ hosName }}</p>
              <p class="fs16 mt10 flex jcc">处方笺</p>
              <span class="sign signC" v-if="subStatus">已提交</span>
              <span class="sign" v-else>未提交</span>
              <div class="pat-info flex column">
                <div class="flex pl30 mt30">
                  <span class="info-label">姓名：</span
                  ><span class="info-item">{{ patientInfo.compatName }}</span>
                  <span class="info-label">性别：</span
                  ><span class="info-item">{{
                    patientInfo.compatGender | sexFilter(1)
                  }}</span>
                  <span class="info-label">年龄：</span
                  ><span class="info-item">{{ patientInfo.compatAge }}</span>
                  <span class="info-label">科别：</span
                  ><span class="info-item">{{ patientInfo.deptName }}</span>
                  <span class="info-label">过敏史：</span>
                  <el-autocomplete
                    style="width: 300px"
                    size="mini"
                    v-model="tabsList[idx].allergyHistoryValue"
                    :fetch-suggestions="allergy"
                    @select="
                      (selectItem) => {
                        allergyHandleSelect(selectItem);
                      }
                    "
                    @keydown.native="deleteAllergyHistory"
                  ></el-autocomplete>
                </div>
                <div class="flex pl30 mt15">
                  <span class="info-label">总贴数：</span
                  ><span
                    class="info-item1 width20 ellipsis"
                    v-if="!allergyHistoryShow1"
                    @click="allergyHistoryShow1 = !allergyHistoryShow1"
                    >{{ tabsList[idx].tcmDosage }}</span
                  >
                  <el-input
                    size="mini"
                    v-model="tabsList[idx].tcmDosage"
                    v-else
                    @blur="allergyHistoryBlur1"
                    class="width50"
                    autofocus
                  ></el-input>
                  <span class="info-label">电话：</span
                  ><span class="info-item">{{ patientInfo.compatMobile }}</span>
                  <span class="info-label">开方日期：</span
                  ><span class="info-item">{{ tDate }}</span>
                  <span class="info-label">住址：</span
                  ><span class="info-item width20 ellipsis">{{
                    patientInfo.areaName
                  }}</span>
                </div>
                <div class="flex pl30 mt15">
                  <span class="info-label">诊断：</span
                  ><span
                    class="info-item width100 ellipsis"
                    v-if="!diagnosisShow"
                    @click="diagnosisShow = !diagnosisShow"
                    >{{ tabsList[idx].diagnosisValue }}</span
                  >
                  <el-autocomplete
                    style="width: 100%"
                    size="mini"
                    v-else
                    v-model="tabsList[idx].diagnosisValue"
                    :fetch-suggestions="fetchDiagnosis"
                    @select="
                      (item) => {
                        selectDiagnose(item);
                      }
                    "
                    @keydown.native="deleteDiagnosis"
                  ></el-autocomplete>
                </div>
              </div>
              <div class="medicine-table">
                <el-table
                  :data="tabsList[idx].drugList"
                  border
                  style="width: 100%"
                >
                  <el-table-column type="index" width="20"></el-table-column>
                  <el-table-column prop="name" label="药品名称">
                    <template slot-scope="scope">
                      <el-autocomplete
                        size="mini"
                        style="width: 300px"
                        v-model="scope.row.name"
                        :fetch-suggestions="HerbsfetchMedicine"
                        @select="
                          (selectItem) => {
                            HerbshandleSelect(selectItem, scope.$index);
                          }
                        "
                      ></el-autocomplete>
                    </template>
                  </el-table-column>
                  <el-table-column prop="unit" label="单位"></el-table-column>
                  <el-table-column
                    prop="originPlace"
                    label="药品产地"
                  ></el-table-column>
                  <el-table-column prop="price" label="单价">
                    <template> </template>
                  </el-table-column>
                  <el-table-column prop="drugAdmission" label="用法">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.admissionId" size="mini">
                        <el-option
                          v-for="item in drugAdmissionList"
                          :key="item.id"
                          :label="item.dicName"
                          :value="item.dicCode"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="frequencyCode" label="使用频次">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.dicCode" size="mini">
                        <el-option
                          v-for="item in drugFrequencyList"
                          :key="item.id"
                          :label="item.dicName"
                          :value="item.dicCode"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="attachId" label="附加">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.attachId" size="mini">
                        <el-option
                          v-for="item in singleDoseList"
                          :key="item.id"
                          :label="item.dicName"
                          :value="item.dicName"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="perMount" label="每贴数量">
                    <template slot-scope="scope">
                      <el-input
                        size="mini"
                        v-model="scope.row.amount"
                      ></el-input>
                    </template>
                  </el-table-column>
                  
                  
                  <el-table-column prop="date" label="操作">
                    <template slot-scope="scope">
                      <span
                        class="color_red fs18 pointer"
                        v-if="tabsList[idx].drugList.length > 1"
                        @click="medicineDelete(scope.$index, scope.row)"
                        >x</span
                      >
                      <span
                        class="color_main fs18 pointer ml10"
                        v-if="scope.$index == tabsList[idx].drugList.length - 1"
                        @click="medicineAdd(scope.$index, scope.row)"
                        >+</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 共享处方 -->
    <el-drawer :visible.sync="dialogVisible" size="80%">
      <el-table :data="gridData">
        <el-table-column
          width="150"
          property="tradedate"
          label="开方日期"
        ></el-table-column>
        <el-table-column
          width="200"
          property="miname"
          label="医疗机构名称"
        ></el-table-column>
        <el-table-column
          width="100"
          property="tradecuretype"
          label="医疗类别"
        ></el-table-column>
        <el-table-column
          width="100"
          property="tradefundtype"
          label="险种类型"
        ></el-table-column>
        <el-table-column
          property="recipeno"
          label="处方号码"
          width="250"
        ></el-table-column>
        <el-table-column
          property="diag"
          label="处方诊断"
          width="150"
        ></el-table-column>
        <el-table-column label="详情" width="130">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click.prevent="getDetails(scope.row)"
              >处方详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-drawer size="70%" :append-to-body="true" :visible.sync="innerDrawer">
        <el-table :data="durgData">
          <el-table-column
            property="fee_type"
            label="费用类别"
          ></el-table-column>
          <el-table-column property="itemname" label="名称"></el-table-column>
          <el-table-column
            property="specification"
            label="规格"
          ></el-table-column>
          <el-table-column
            property="dose"
            label="剂型"
          ></el-table-column>
          <el-table-column property="unitprice" label="单价"></el-table-column>
          <el-table-column property="count" label="数量"></el-table-column>
          <el-table-column property="unit" label="单位"></el-table-column>
          <el-table-column property="dosage" label="一次剂量"></el-table-column>
          <el-table-column property="minpackage" label="剂量单位"></el-table-column>
          <el-table-column property="howtouse" label="用法"></el-table-column>
          <el-table-column property="days" label="天数"></el-table-column>
          <el-table-column property="fee" label="总金额"></el-table-column>
        </el-table>
      </el-drawer>
    </el-drawer>
  </div>
</template>

<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import { tokenCache } from "../../../cache/tokenCache";
import { sexFilter } from "../../lib/filters";
import { timeFormat, isEmpty } from "../../lib/utils";

const PAGE = {
  pageNum: 1,
  pageSize: 5,
  pages: 1,
  total: 0,
};
export default {
  data() {
    return {
      durgData:[],
      innerDrawer: false,
      gridData: [],
      display: true,
      dialogVisible: false,
      fullscreenLoading: false,
      hosName: JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosName,
      activeTab: "1",
      tabIndex: 1,
      idx: 0,
      tabsList: [],
      patientInfo: {},
      medicineList: [],
      medicine: "",
      addMedicineList: [],
      tDate: "",
      drugAdmissionList: [], //用法
      drugFrequencyList: [], //频次
      singleDoseList: [], //单次剂量
      diagnosisKey: "",
      diagnosis: "",
      diagnosisTemp: "",
      diagnosisShow: false,
      allergyHistory: "",
      PasteNumber: "",
      allergyHistoryShow: false,
      allergyHistoryShow1: false,
      reSub: false,
      diagnosisList:[],
      diagnosisList1:[],
      daterange: [],
      filtersForm: {
        patName: "",
        startDate: "",
        endDate: "",
      },
      list: [],
      loading: false,
      page: PAGE,
      page2: PAGE,
      checkedStatus: "WAITCONTRACT",
      historyRpList: [],
      clientHeight: this.$store.state.clientH - 100,
      userInfo: JSON.parse(sessionStorage.getItem("loginInfo")).doc,
      subStatus: false,
      prescriptionList: [],
      diagnosisListData: [],
      allergyList:[],
      patientNumber: "",
      rulesTable: {
        name: [{ required: true, message: "药品名称", trigger: "blur" }],
      },
    };
  },
  filters: {
    sexFilter,
    timeFormat,
  },
  watch: {
    daterange(val) {
      this.filtersForm.startDate = val ? val[0] : "";
      this.filtersForm.endDate = val ? val[1] : "";
    },
    checkedStatus: {
      handler() {
        this.pages = PAGE;
      },
      immediate: true,
    },
  },
  props: ["userobj"],
  mounted() {
    this.getPatientInfo();
    const tDate = new Date();
    this.tDate = timeFormat(tDate, "%Y/%m/%d");
  },
  methods: {
    getDetails(row) {
      this.durgData=row.itemlist.item;
      this.innerDrawer = true;
    },
    shareClick() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.yygh.ApiyGHpaymentService.prescription.record",
          ddid: that.userobj.ddid,
          orgid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          token: tokenCache.get(),
        },
        ({ code, recipeList, msg }) => {
          if (code == "0") {
            that.gridData = recipeList;
            that.dialogVisible = true;
          }
        }
      );
    },
    handleClose() {
      this.dialogVisible = false;
    },
    formatterType(row, column, code) {
      const orderType = {
        WESTERN_RECIPE: "西药方",
        CHINESE_RECIPE: "草药方",
        PRESCRIPT_RECIPE: "成药方",
      };
      return orderType[code];
    },
    initprescriptionList(bizId) {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.recipe.order.opendoc.list.page.diagnosis",
          bizId: bizId,
          status: "REBACK",
          token: tokenCache.get(),
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            for (let i in list) {
              list[i].diagnosisListData = [];
              for (let j in list[i].diagnosisList) {
                list[i].diagnosisList[j].checked = false;
              }
            }
            that.prescriptionList = list;
          }
        }
      );
    },
    amount(row) {
      row.amount = Number(row.dosage);
    },
    //通过选择药品信息获取天数
    getDays(idx, row) {
      let that = this;
      if (!row.amount) {
        return;
      }
      if (!row.drugCode) {
        return;
      }
      if (!row.dose) {
        return;
      }
      if (!row.dicCode) {
        return;
      }
      axiosUtil(
        {
          service: "smarthos.yygh.calculate.medication.day",
          hosid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          code: row.drugCode,
          count: row.amount,
          dose: row.dose,
          frequency: row.dicCode,
        },
        ({ code, calculateMedicationDay, msg }) => {
          if (code == "0") {
            that.$set(row, "useDays", calculateMedicationDay.days);
          }
        }
      );
    },
    regTestVal(value, reg) {
      this.$nextTick(() => {
        value = value.replace(/[^\d.]/g, "");
        value = value.replace(/\.{2,}/g, ".");
        value = value.replace(/^\./g, "0.");
        value = value.replace(
          /^\d*\.\d*\./g,
          value.substring(0, value.length - 1)
        );
        value = value.replace(/^0[^\.]+/g, "0");
        value = value.replace(/^(\d+)\.(\d\d\d\d).*$/, "$1.$2");
        reg.dosage = value;
      });
    },
    async getPatientInfo() {
      const ddId = this.userobj.ddid;
      // const ddId = '10001467'
      // const ddId = "10001506"
      const { code, obj } = await this.$http(
        "smarthos.online.outpatient.pack.info",
        { id: ddId }
      );
      this.patientInfo = obj.userInfo;
      this.patientInfo.jzkh = obj.ddxx.obj.jzkh;
      let object = {
        title: "西成药方1",
        name: "1",
        orderType: "WESTERN_RECIPE",
        diagnosisValue: "",
        diagnosisName: "",
        allergyHistory: "",
        drugList: [{}],
        repeatDrugId: [],
        allergyHistoryId: [],
        allergyHistoryValue: "",
        diagnosisArray:[]
      };
      this.tabsList.push(object);
      this.getMedicineList();
      this.getMedicineParams();
    },
    async getMedicineList(key) {},
    async allergy(queryString, cb) {
      let that=this;
      const index = queryString.lastIndexOf(",");
      const key = queryString.substring(index + 1, queryString.length);
      if(key==''&&JSON.stringify(that.allergyList)!='[]'){
        cb(that.allergyList);
        return
      }
      const options = {
        hosid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        drugName: key,
        pagenum: "1",
        pagesize: "100",
        token: tokenCache.get(),
      };
      let { code, drugList } = await this.$http(
        "smarthos.yygh.allergic.history.page.list",
        options
      );
      if (code == "0") {
        for (let i of drugList) {
          i.value = i.drugName; //必须绑定value值作为显示数据
        }
        that.allergyList=drugList;
        cb(drugList);
      }
    },
    async HerbsfetchMedicine(queryString, cb) {
      const options = {
        drugType: "CHINESE",
        hosid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        drugName: "",
        token: tokenCache.get(),
      };
      let { code, drugEntityList } = await this.$http(
        "smarthos.yygh.medical.list.by.name",
        options
      );
      if (code == "0") {
        for (let i of drugEntityList) {
          i.value =
            i.name +
            " " +
            i.originPlace; //必须绑定value值作为显示数据
        }
        cb(drugEntityList);
      }
    },
    async fetchMedicine(queryString, cb) {
      const options = {
        drugName: queryString,
        hosId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        drugType: "WESTERNPRESCRIPT",
        token: tokenCache.get(),
        // ...this.page,
      };
      let { code, drugEntityList } = await this.$http(
        "smarthos.yygh.medical.list.by.name",
        options
      );
      if (code == "0") {
        for (let i of drugEntityList) {
          i.value =
            i.name +
            " " +i.originPlace; //必须绑定value值作为显示数据
        }
        cb(drugEntityList);
      }
    },
    async fetchDiagnosis(queryString, cb) {
      let that=this;
      const index = queryString.lastIndexOf(";");
      const key = queryString.substring(index + 1, queryString.length);
      if(key==''&&JSON.stringify(that.diagnosisList)!='[]'){
        cb(that.diagnosisList);
        return
      }
      const options = {
        diagname: key,
        pageSize: "100",
        pageNum: "1",
        token: tokenCache.get(),
      };
      let { code, diagnosisList } = await this.$http(
        "smarthos.yygh.select.diagnostic.dictionary.info.list.new",
        options
      );
      if (code == "0") {
        if (diagnosisList) {
          let list = diagnosisList;
          for (let i of list) {
            i.value = i.diagnosisName; //必须绑定value值作为显示数据
          }
          that.diagnosisList=list;
          cb(list);
        }
      }
    },
    async fetchDiagnosis1(queryString, cb) {
      let that=this;
      const index = queryString.lastIndexOf(";");
      const key = queryString.substring(index + 1, queryString.length);
      if(key==''&&JSON.stringify(that.diagnosisList1)!='[]'){
        cb(that.diagnosisList1);
        return
      }
      const options = {
        qKey: key,
        pageNum: "1",
        token: tokenCache.get(),
      };
      let { code, obj } = await this.$http(
        "smarthos.drugs.online.diagnosis.query",
        options
      );
      if (code == "0") {
        if (obj.list) {
          let list = obj.list;
          for (let i of list) {
            i.value = i.dicName; //必须绑定value值作为显示数据
          }
          that.diagnosisList1=list;
          cb(list);
        }
      }
    },
    HerbshandleSelect(item, index) {
      this.tabsList[this.idx].repeatDrugId.push(item.id);
      this.tabsList[this.idx].drugList[index] = item;
      this.$set(
        this.tabsList[this.idx].drugList[index],
        "dosage",
        item.eachDose
      );
    },
    handleSelect(item, index) {
      this.tabsList[this.idx].repeatDrugId.push(item.id);
      this.tabsList[this.idx].drugList[index] = item;
      this.$set(
        this.tabsList[this.idx].drugList[index],
        "dosage",
        item.eachDose
      );
    },
    allergyHandleSelect(item) {
      if (this.tabsList[this.idx].allergyHistory != "") {
        this.tabsList[this.idx].allergyHistory =
          this.tabsList[this.idx].allergyHistory + item.drugName + ",";
        this.tabsList[this.idx].allergyHistoryValue =
          this.tabsList[this.idx].allergyHistory;
        this.tabsList[this.idx].allergyHistoryId.push(item.drugName);
      } else {
        this.tabsList[this.idx].allergyHistory = item.drugName + ",";
        this.tabsList[this.idx].allergyHistoryValue = item.drugName + ",";
        this.tabsList[this.idx].allergyHistoryId.push(item.drugName);
      }
    },
    selectDiagnose(item) {
      if (this.tabsList[this.idx].diagnosisName != "") {
        let n = this.tabsList[this.idx].diagnosisName.split(";").length;
        if (n <= 10) {

          this.tabsList[this.idx].diagnosisName =
            this.tabsList[this.idx].diagnosisName + item.diagnosisName + ";";
          this.tabsList[this.idx].diagnosisValue =
            this.tabsList[this.idx].diagnosisName;
            this.tabsList[this.idx].diagnosisArray.push(item.diagnosisName)
        } else {
          this.tabsList[this.idx].diagnosisValue =
            this.tabsList[this.idx].diagnosisName;
          this.$message.error("输入诊断数量不能超过10个！");
        }
      } else {
        this.tabsList[this.idx].diagnosisArray.push(item.diagnosisName)
        this.tabsList[this.idx].diagnosisName = item.diagnosisName + ";";
        this.tabsList[this.idx].diagnosisValue = item.diagnosisName + ";";
      }
    },
    deleteAllergyHistory(e) {
      if (e.keyCode && e.keyCode===8) {
        //[...new Set(arr)] 
        let array=this.tabsList[this.idx].allergyHistoryValue.split(',').filter(item=>item!='');
        //删除最后一个元素
        this.tabsList[this.idx].allergyHistoryId.pop()

        let newList=this.tabsList[this.idx].allergyHistoryId
        //去重
        let temp_arr=[...new Set(newList)]
        this.tabsList[this.idx].allergyHistory=temp_arr.join(',')+',';
        this.tabsList[this.idx].allergyHistoryValue=this.tabsList[this.idx].allergyHistory+',';
      }
    },
    deleteDiagnosis(e) {
      if (e.keyCode == 8) {
        //[...new Set(arr)] 
        // let array=this.tabsList[this.idx].allergyHistoryValue.split(',').filter(item=>item!='');
        //删除最后一个元素
        this.tabsList[this.idx].diagnosisArray.pop()

        let newList=this.tabsList[this.idx].diagnosisArray
        //去重
        let temp_arr=[...new Set(newList)]
        this.tabsList[this.idx].diagnosis=temp_arr.join(';')+';';
        this.tabsList[this.idx].diagnosisValue=this.tabsList[this.idx].diagnosis+';';
        this.tabsList[this.idx].diagnosisName=this.tabsList[this.idx].diagnosisValue;
      }
    },
    async getMedicineParams() {
      const { code, obj } = await this.$http(
        "smarthos.drugs.online.prescription.dictionary",
        {}
      );
      this.drugAdmissionList = obj.drugUsageNewList;
      for (let i of obj.useFrequencyList) {
        i.frequencyObj = i.dicName;
      }
      this.drugFrequencyList = obj.useFrequencyList;
      this.singleDoseList = obj.herbSubjoinList;
    },
    addTab(targetName) {
      if (targetName == "1") {
        const index = ++this.tabIndex;
        let newTabName = index + "";
        this.tabsList.push({
          title: "西成药方" + newTabName,
          name: newTabName,
          orderType: "WESTERN_RECIPE",
          allergyHistory: this.tabsList[this.idx].allergyHistory,
          diagnosisName: this.tabsList[this.idx].diagnosisName,
          diagnosisValue: this.tabsList[this.idx].diagnosisValue,
          drugList: [{}],
          repeatDrugId: [],
          allergyHistoryId: this.tabsList[this.idx].allergyHistoryId,
          allergyHistoryValue: this.tabsList[this.idx].allergyHistoryValue,
          diagnosisArray:this.tabsList[this.idx].diagnosisArray
        });
        this.activeTab = newTabName;
        this.idx = this.tabsList.length - 1;
      } else if (targetName == "3") {
        const index = ++this.tabIndex;
        let newTabName = index + "";
        this.tabsList.push({
          title: "草药方" + newTabName,
          name: newTabName,
          orderType: "CHINESE_RECIPE",
          allergyHistory: this.tabsList[this.idx].allergyHistory,
          diagnosisName: this.tabsList[this.idx].diagnosisName,
          diagnosisValue: this.tabsList[this.idx].diagnosisValue,
          tcmDosage: "1",
          drugList: [{}],
          repeatDrugId: [],
          allergyHistoryId: this.tabsList[this.idx].allergyHistoryId,
          allergyHistoryValue:this.tabsList[this.idx].allergyHistoryValue,
          diagnosisArray:this.tabsList[this.idx].diagnosisArray
        });
        this.activeTab = newTabName;
        this.idx = this.tabsList.length - 1;
      }
    },
    tabChange() {
      this.idx = this.activeTab - 1;
    },
    removeTab(targetName) {
      this.$confirm(
        `是否确定删除${
          this.tabsList[targetName - 1].title
        },删除后不可恢复，仍要继续该操作？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let tabs = this.tabsList;
          let activeName = this.activeTab;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          this.activeTab = activeName;
          this.tabsList = tabs.filter((tab) => tab.name !== targetName);
          this.idx = this.tabsList.length - 1;
          // this.$message({
          //   type: "success",
          //   message: "删除成功!",
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelectionChange(val) {
      this.addMedicineList = val;
    },
    addMedicine() {
      if (this.tabsList[this.idx].drugList.length > 0) {
        const aL = this.addMedicineList.map((r) => {
          r.admission = r.drugAdmission;
          if (!this.tabsList[this.idx].drugList.includes(r)) {
            this.tabsList[this.idx].drugList.push(r);
          }
        });
      } else {
        const aL = this.addMedicineList.map((r) => {
          this.tabsList[this.idx].drugList.push(r);
        });
      }

      // this.allPrescritionList[this.activeTab].selectedM =
      //   this.selectedMedicineListTemp;
    },
    medicineDelete(i, r) {
      this.tabsList[this.idx].drugList.splice(i, 1);
    },
    medicineAdd() {
      this.tabsList[this.idx].drugList.push({});
    },
    allergyHistoryBlur1() {
      this.allergyHistoryShow1 = !this.allergyHistoryShow;
    },
    allergyHistoryBlur() {
      this.allergyHistoryShow = !this.allergyHistoryShow;
      this.allPrescritionList[this.activeTab].allergyHistory =
        this.allergyHistory;
    },
    getCurrentTime() {
      //获取当前时间并打印
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let gettime = yy + "-" + mm + "-" + dd;
      return gettime;
    },
    async submitPrescription() {
      let that = this;
      const load = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let diagnosisList = [];
      let prescriptionDetailList = [];
      let tcmDosage = "";
      for (let i in this.tabsList) {
        for (let u in this.tabsList[i].drugList) {
          let obj = {};
          obj.code = this.tabsList[i].drugList[u].drugCode;
          obj.count = this.tabsList[i].drugList[u].amount;
          obj.dose = this.tabsList[i].drugList[u].dose;
          obj.frequency = this.tabsList[i].drugList[u].dicCode;
          obj.usage = this.tabsList[i].drugList[u].admissionId;
          obj.name = "";
          obj.unit = "";
          obj.doseUnit = "";
          obj.price = this.tabsList[i].drugList[u].price;
          if (this.tabsList[i].drugList[u].attachId) {
            obj.attachName = this.tabsList[i].drugList[u].attachId;
          }
          if (this.tabsList[i].orderType == "WESTERN_RECIPE") {
            obj.prescriptionCount = "1";
            tcmDosage = "";
          } else {
            obj.prescriptionCount = this.tabsList[i].tcmDosage;
            tcmDosage = this.tabsList[i].tcmDosage;
          }
          prescriptionDetailList.push(obj);
        }
        let diagnosis = this.tabsList[i].diagnosisName.split(";");
        for (let j = 0; j < diagnosis.length - 1; j++) {
          if (JSON.stringify(diagnosisList) != "[]") {
            for (let o in diagnosisList) {
              if (diagnosisList[o].diagnosisName == diagnosis[j]) {
              }
            }
          } else {
            let obj = {};
            obj.diagnosisName = diagnosis[j];
            obj.ICD10Code = "";
            obj.diagnosisRemark = "";
            diagnosisList.push(obj);
          }
        }
      }

      const options = {
        hosId:JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        bookId: this.userobj.ddid,
        prescriptionDate: that.getCurrentTime(),
        diagnosisList: JSON.stringify(diagnosisList),
        prescriptionDetailList: JSON.stringify(prescriptionDetailList),
        allergicDrugs: this.tabsList[this.idx].allergyHistory,
        patId: that.patientInfo.patId,
        compatId: that.patientInfo.compatId,
        compatAddress: that.patientInfo.areaName,
        patientNumber: that.patientInfo.jzkh,
        allergyHistoryList: this.tabsList[this.idx].allergyHistoryId,
        token: tokenCache.get(),
        tcmDosage: tcmDosage,
      };
      const { code, obj, msg } = await this.$http(
        // "smarthos.yygh.bjyl.prescription.medical.check",
        "smarthos.recipe.prescription.medical.check",
        options
      );
      load.close();
      if (code == "0") {
        that.$message({
          type: "success",
          message: "保存成功,请前往处方列表签名",
        });
        that.$router.push({ path: "/main/prescription-list" });
      }
    },
    async reSubPrescription(id) {
      this.fullscreenLoading = true;
      const options = {
        orderId: this.$route.query.rpId,
        patId: this.patientInfo.patId,
        compatId: this.patientInfo.compatId,
        compatName: this.patientInfo.compatName,
        compatGender: this.patientInfo.compatGender,
        compatMobile: this.patientInfo.compatMobile,
        compatAge: this.patientInfo.compatAge,
        compatAddress: "",
        bizId: this.$route.query.bizId,
        type: "2",
        recipeOrderList: this.tabsList,
        patientNumber: this.patientNumber,
        token: tokenCache.get(),
      };
      const { code, obj } = await this.$http(
        "smarthos.recipe.order.fenghuang.new.add",
        // "smarthos.recipe.order.add.new",
        options
      );
      this.fullscreenLoading = false;
      if (code == "0") {
        if (obj.recipeOrderList) {
          this.dialogVisible = true;
          this.initprescriptionList(obj.bizId);
        } else {
          this.$message({
            type: "success",
            message: "保存成功,请前往处方列表签名",
          });
        }
      }
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getMedicineList();
    },
  },
};
</script>

<style lang="scss">
.prescription {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}

.record-item {
  padding: 15px 15px;
  .record-item-title {
    span {
      width: 4px;
      height: 14px;
      background-color: #3692f9;
      margin-right: 10px;
    }
  }
  .record-item-content {
    padding: 5px 15px;
    font-size: 14px;
    color: #999999;
  }
}

.info-label {
  font-size: 14px;
  color: #333333;
}

.info-item {
  font-size: 14px;
  color: #666666;
  margin-right: 60px;
  border-bottom: 1px solid #333333;
  padding: 0 10px;
}

.info-item1 {
  font-size: 14px;
  color: red;
  margin-right: 60px;
  border-bottom: 1px solid #333333;
  padding: 0 10px;
}

.un-sel {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1px solid #3692f9;
  border-radius: 50%;
}

.selected {
  background-color: #3692f9;
}

.el-table__header-wrapper {
  .cell {
    label.el-checkbox {
      display: none !important;
    }
  }
}

.medicine-table {
  padding: 0 5px;
  height: 70%;
  overflow-y: auto;
  .el-table__header-wrapper {
    .cell {
      font-size: 14px;
      font-weight: normal;
      color: #000;
    }
  }
}

.sign {
  width: 65px;
  height: 25px;
  position: absolute;
  top: 30px;
  left: 70px;
  color: white;
  background-color: red;
  border-radius: 2px;
  text-align: center;
  transform: rotateZ(-45deg);
}
.signC {
  background-color: #ffffff;
  border: 1px solid #58a4fa;
  color: #58a4fa;
}
</style>
